import type { PersonaHeaderProps, PersonaHeader as PersonaHeaderComponent, } from "./components/PersonaHeader/PersonaHeader";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "PeopleExperiences"*/ "./lazyIndex"), { name: "PeopleExperiences" });

export type { default as HeaderButtonData } from "./models/HeaderButtonData";

export const PersonaHeader: LazyComponent<PersonaHeaderProps, PersonaHeaderComponent, void> = createLazyComponent(lazyModule, m => m.PersonaHeader);
